import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthServiceCustom } from 'src/app/core/auth/authServiceCustom';
import { NgxSpinnerService } from 'ngx-spinner';
import { SessionBusiness } from 'src/app/core/_config/sessionBusiness.service';
import * as _ from 'lodash';
import { AutomaticDebitService } from '../../services/automatic-debit.service';
import { NotificationsService } from 'angular2-notifications';
import { AutomaticDebitRetFile } from '../../models/automaticDebitRetFile';

@Component({
    selector: 'automatic-debit-import',
    templateUrl: './automatic-debit-import.component.html',
    styleUrls: ['./automatic-debit-import.component.scss'],
})
export class AutomaticDebitImportComponent implements OnInit {
    loading: boolean = false;
    constructor(
        private authServiceCustom: AuthServiceCustom,
        private spinner: NgxSpinnerService,
        private notificationsService: NotificationsService,
        private router: Router,
        private sessionBusiness: SessionBusiness,
        private automaticDebitService: AutomaticDebitService,
    ) {}

    breadcrumbItems = [
        { label: 'Arquivos REM', route: 'automatic-debit/rem', active: false },
        { label: 'Arquivos RET', route: 'automatic-debit/ret', active: false },
        { label: 'Importar RET', route: 'automatic-debit/ret/import', active: true },
    ];

    selectedFile: File = null;

    ngOnInit(): void {}
    onDragOver(event: DragEvent) {
        event.preventDefault();
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        if (event.dataTransfer?.files.length) {
            this.onSelectFile(event);
        }
    }
    onSelectFile(event: any) {
        let fileInput = event.target;
        const files = event.target.files || event.dataTransfer.files;
        this.selectedFile = files[0];
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        formData.append('legalEntityId', this.sessionBusiness.LegalEntityIdContext);
        formData.append('userName', this.authServiceCustom.userName);

        this.spinner.show();

        this.automaticDebitService.importFile(formData).subscribe(
            (result: AutomaticDebitRetFile) => {
                this.spinner.hide();
                this.resetFileInput(fileInput);
                this.notificationsService.success('Arquivo importado com sucesso!');
                this.router.navigate(['automatic-debit/ret/select-file'], { queryParams: { id: result?.id } });
            },
            (error) => {
                console.error(error);
                this.resetFileInput(fileInput);
            },
        );
    }

    private resetFileInput(fileInput: any) {
        if (fileInput) {
            fileInput.value = '';
        }
    }
}
